// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZoomImage_wrapper__aGHee","box_shadow":"ZoomImage_box_shadow___LlY7","imageContainer":"ZoomImage_imageContainer__TbyQW"};